import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale("es");

// Columnas de la tabla. Sin "Mostrar vendedor" ni "Desglosar impuestos" son las nueve de
// siempre con sus mismos anchos; con cualquiera de las dos la hoja va horizontal y los
// anchos se reparten por peso. Titulos, renglones, subtotales y widths salen de esta lista.
const columnasReporteIngresosAgrupado = (values) => {
    const mostrarVendedor = values.mostrarVendedor === true
    const desglosarImpuestos = values.desglosarImpuestos === true
    const extendido = mostrarVendedor || desglosarImpuestos
    return [
        {titulo: 'Banco', valor: (ingreso) => ingreso.banco, alineacion: 'left', ancho: '10%', peso: 8},
        {titulo: 'Fecha', valor: (ingreso) => ingreso.fechaPago, alineacion: 'center', ancho: '10%', peso: 6},
        {titulo: 'Cliente', valor: (ingreso) => ingreso.cliente || ingreso.proveedor || '', alineacion: 'left', ancho: '20%', peso: 12},
        ...(mostrarVendedor ? [{titulo: 'Vendedor', valor: (ingreso) => ingreso.vendedor || '', alineacion: 'left', peso: 10}] : []),
        {titulo: 'Venta', valor: (ingreso) => ingreso.venta || ingreso.factura || '', alineacion: 'left', ancho: '10%', peso: 7},
        ...(extendido ? [{titulo: 'Origen', valor: (ingreso) => ingreso.origen || '', alineacion: 'left', peso: 6}] : []),
        {titulo: 'Proyecto', valor: (ingreso) => ingreso.proyecto, alineacion: 'left', ancho: '10%', peso: 6},
        {titulo: 'Forma De Pago', valor: (ingreso) => ingreso.formaDePago || '', alineacion: 'left', ancho: '12%', peso: 8},
        {titulo: 'Moneda', valor: (ingreso) => ingreso.moneda, alineacion: 'center', ancho: '8%', peso: 4},
        ...(desglosarImpuestos ? [
            {titulo: 'Subtotal', campo: 'subtotal', dinero: true, peso: 8},
            {titulo: 'IVA', campo: 'iva', dinero: true, peso: 8},
            ...(values.hayOtrosImpuestos ? [{titulo: 'Otros Imp.', campo: 'otrosImpuestos', dinero: true, peso: 8}] : []),
            {titulo: 'Retenciones', campo: 'retenciones', dinero: true, peso: 8},
        ] : []),
        {titulo: desglosarImpuestos ? 'Total' : 'Monto', campo: 'monto', dinero: true, ancho: '10%', peso: 8},
        {titulo: 'Referencia', valor: (ingreso) => ingreso.referencia, alineacion: 'left', ancho: '10%', peso: 6},
    ]
}

// Arreglo nuevo en cada llamada: pdfMake muta los widths que recibe
const anchosReporteIngresosAgrupado = (columnas, extendido) => {
    if (!extendido) return columnas.map((columna) => columna.ancho)
    const pesoTotal = columnas.reduce((acc, columna) => acc + columna.peso, 0)
    return columnas.map((columna) => (Math.floor((columna.peso / pesoTotal) * 10000) / 100) + '%')
}

const textoDineroAgrupado = (valor) => (valor === null || valor === undefined ? '' : dineroDisabledMask(valor))

const celdasVacias = (cantidad) => Array.from({length: cantidad}, () => ({}))

const reporteDeIngresosAgrupadosPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    const extendido = values.mostrarVendedor === true || values.desglosarImpuestos === true
    const agruparPorVendedor = values.mostrarVendedor === true && values.agruparPdfPor === 'vendedor'
    const columnas = columnasReporteIngresosAgrupado(values)
    const totalColumnas = columnas.length
    const primeraColumnaDinero = columnas.findIndex((columna) => columna.dinero)
    const estiloTexto = extendido ? 'textoTablaChica' : 'textoTabla'
    let filtrados = []
    if(values.bancos !== 0 && values.bancos && values.bancos.length > 0){
        let textoFiltrado = ''
        values.bancos.map((valueBanco) => {
            textoFiltrado += `${valueBanco.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Bancos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    if(values.vendedores && values.vendedores.length > 0){
        let textoFiltrado = ''
        values.vendedores.map((valueVendedor) => {
            textoFiltrado += `${[valueVendedor.nombre, valueVendedor.apellidoPaterno, valueVendedor.apellidoMaterno].filter(Boolean).join(' ')}\n`
            return null
        })
        filtrados.push([
            {text: 'Vendedores:', style: 'subheader'},

            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    // Agrupar ingresos por forma de pago (o por vendedor si asi se pidio en Detalles)
    const claveGrupo = (ingreso) => agruparPorVendedor
        ? ((ingreso.vendedor && ingreso.vendedor.trim()) || 'Sin vendedor')
        // Verificar si existe formaDePago y limpiarlo, si no existe asignar 'Sin especificar'
        : ((ingreso.formaDePago && ingreso.formaDePago.trim()) || 'Sin especificar');
    const etiquetaGrupo = agruparPorVendedor ? 'VENDEDOR' : 'FORMA DE PAGO';

    const ingresosAgrupados = values.pagos.reduce((grupos, ingreso) => {
        const grupo = claveGrupo(ingreso);
        if (!grupos[grupo]) {
            grupos[grupo] = [];
        }
        grupos[grupo].push(ingreso);
        return grupos;
    }, {});

    const gruposOrdenados = agruparPorVendedor
        ? Object.keys(ingresosAgrupados).sort((a, b) => a.localeCompare(b, 'es'))
        : Object.keys(ingresosAgrupados);

    const sumarColumna = (ingresos, campo) => ingresos.reduce((acc, ingreso) => acc + parseFloat(ingreso[campo] || 0), 0);

    // Fila de subtotal / total: la etiqueta ocupa todo lo que esta antes de la primera
    // columna de dinero; despues va un importe por cada columna de dinero
    const filaDeSumas = (etiqueta, ingresos, estiloEtiqueta, estiloImporte, fillColor, conBordes) => [
        {
            text: etiqueta,
            style: estiloEtiqueta,
            alignment: 'right',
            colSpan: primeraColumnaDinero,
            ...(conBordes ? {border: [true, true, true, true]} : {}),
            fillColor
        },
        ...celdasVacias(primeraColumnaDinero - 1),
        ...columnas.slice(primeraColumnaDinero).map((columna, index) => columna.dinero
            ? {
                text: dineroDisabledMask(sumarColumna(ingresos, columna.campo)),
                style: estiloImporte,
                alignment: 'right',
                ...(conBordes ? {border: [true, true, true, true]} : {}),
                fillColor
            }
            : {
                text: '',
                style: estiloImporte,
                ...(conBordes ? {border: [false, true, primeraColumnaDinero + index === totalColumnas - 1, true]} : {}),
                fillColor
            }
        ),
    ];

    let pagos = [];

    // Construir la tabla con ingresos agrupados
    gruposOrdenados.forEach(grupo => {
        const ingresosDelGrupo = ingresosAgrupados[grupo];

        // Ordenar por fecha dentro de cada grupo
        ingresosDelGrupo.sort((a, b) => {
            const fechaA = moment(a.fechaPago, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY']);
            const fechaB = moment(b.fechaPago, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY']);
            return fechaA.isBefore(fechaB) ? -1 : fechaA.isAfter(fechaB) ? 1 : 0;
        });

        // Encabezado del grupo
        pagos.push([
            {
                text: `${etiquetaGrupo}: ${grupo}`,
                style: 'clienteTabla',
                alignment: 'center',
                colSpan: totalColumnas,
                fillColor: '#e6f3ff',
            },
            ...celdasVacias(totalColumnas - 1)
        ]);

        // Filas de ingresos del grupo (ya ordenados por fecha)
        ingresosDelGrupo.forEach(ingreso => {
            pagos.push(columnas.map((columna) => columna.dinero
                ? {
                    text: columna.campo === 'monto'
                        ? dineroDisabledMask(parseFloat(ingreso.monto || 0))
                        : textoDineroAgrupado(ingreso[columna.campo]),
                    style: estiloTexto,
                    alignment: 'right'
                }
                : { text: columna.valor(ingreso), style: estiloTexto, alignment: columna.alineacion }
            ));
        });

        // Subtotal del grupo
        pagos.push(filaDeSumas(`Subtotal ${grupo}:`, ingresosDelGrupo, 'textoTabla', estiloTexto, '#f0f8ff', false));

        // Línea separadora entre grupos
        pagos.push([
            {
                text: '',
                style: 'textoTabla',
                colSpan: totalColumnas,
                border: [false, false, false, true],
                borderColor: ['', '', '', '#666666']
            },
            ...celdasVacias(totalColumnas - 1)
        ]);
    });

    // TOTAL GENERAL
    pagos.push(filaDeSumas('TOTAL GENERAL:', values.pagos, 'tituloTabla', estiloTexto, '#cccccc', true));

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},
            {text: '', style: 'textoChico'}
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              {
                                  border: [false, false, false, false],
                                  image: 'logo',
                                  fit: [80, 80] 
                              },
                              {
                                  border: [false, false, false, false],
                                  table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                        [
                                            { 
                                            text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                            style: "tableHeader" 
                                            }
                                        ],
                                        [
                                          {
                                            text: "R.F.C: "+empresa.rfc,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                        [
                                            {
                                              text: empresa.calle+' '+
                                                    empresa.numeroCalle+' '+
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                        [
                                            {
                                              text: empresa.colonia.tipoAsentamiento+' '+
                                              empresa.colonia.nombre+' C.P. '+
                                              empresa.colonia.cp+' '+
                                              empresa.municipio.nombre+' '+
                                              empresa.estado.abreviatura+' '+
                                              empresa.pais.abreviatura+' '
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                          [{text: agruparPorVendedor ? 'REPORTE DE INGRESOS POR VENDEDOR' : 'REPORTE DE INGRESOS AGRUPADOS', style: 'tableHeader'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                          ]
                      ]
                  },
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: filtrados,
                  },
                  layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                  }
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: anchosReporteIngresosAgrupado(columnas, extendido),
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          columnas.map((columna) => ({text: columna.titulo, style: 'tituloTabla'})),
                          ...pagos
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          // Conservar colores especiales para encabezados de grupo y subtotales
                          if (node.table.body[rowIndex] && node.table.body[rowIndex][0] && node.table.body[rowIndex][0].fillColor) {
                              return node.table.body[rowIndex][0].fillColor;
                          }
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                  }
              },
              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              textoTotal: {
                fontSize: 7,
                italics: false
              },
              clienteTabla: {
                fontSize: 10,
                bold: true,
                italics: false,
                fillColor: '#ecfdfe',
              },
              ...(extendido ? {
                  textoTablaChica: {
                      fontSize: 7,
                      italics: false
                  },
              } : {}),
          },
          pageSize: 'LETTER',
          ...(extendido ? {pageOrientation: 'landscape'} : {}),
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};

export default reporteDeIngresosAgrupadosPdf;